import React, {FC} from 'react';
import Modal from "../../../../shared/modal/modal";
import styles from './verified-confirm-territory-modal.module.scss'
import rejectIcon from '../../../../images/error-120.svg'
import Button from "../../../ui-kit/button/button";
import {useTranslation} from "react-i18next";

interface VerifiedTerritoryModalProps {
    onClose: () => void
    type: 'stage' | 'building';
}

const VerifiedConfirmTerritoryModal: FC<VerifiedTerritoryModalProps> = ({onClose, type}) => {
    const { t } = useTranslation();

    const textByType = {
        stage: {
            text: t('verified-confirm-territory-modal.stageText'),
            description: t('verified-confirm-territory-modal.stageDescription'),
        },
        building: {
            text: t('verified-confirm-territory-modal.buildingText'),
            description: t('verified-confirm-territory-modal.buildingDescription'),
        },
    };

    const { text, description } = textByType[type];

    return (
        <Modal closeOnOverlayClick={false} onClose={onClose}>
            <div className={styles.verifiedConfirmTerritoryModal}>
                <h1 className={styles.title}>{t('verified-confirm-territory-modal.title')}</h1>
                <img className={styles.image} src={rejectIcon} alt='reject'/>
                <span className={styles.text}>{text}</span>
                <p className={styles.description}>{description}</p>
                <Button
                    type='primary'
                    onClick={onClose}
                    className={styles.btn}
                >
                    {t('verified-confirm-territory-modal.back')}
                </Button>
            </div>
        </Modal>
    );
};

export default VerifiedConfirmTerritoryModal;